var React = require('react');

function CTAArrow (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"13.5","cy":"13.5","r":"13.5","fill":"white","key":0}),React.createElement("path",{"d":"M8.40002 11.7C7.5716 11.7 6.90002 12.3716 6.90002 13.2C6.90002 14.0285 7.5716 14.7 8.40002 14.7V11.7ZM18.9 13.2L19.9607 14.2607L21.0213 13.2L19.9607 12.1394L18.9 13.2ZM13.0394 16.9394C12.4536 17.5252 12.4536 18.4749 13.0394 19.0607C13.6252 19.6465 14.5749 19.6465 15.1607 19.0607L13.0394 16.9394ZM15.1607 7.33936C14.5749 6.75358 13.6252 6.75358 13.0394 7.33936C12.4536 7.92515 12.4536 8.8749 13.0394 9.46068L15.1607 7.33936ZM8.40002 14.7H18.9V11.7H8.40002V14.7ZM15.1607 19.0607L19.9607 14.2607L17.8394 12.1394L13.0394 16.9394L15.1607 19.0607ZM19.9607 12.1394L15.1607 7.33936L13.0394 9.46068L17.8394 14.2607L19.9607 12.1394Z","fill":"#EF6E26","key":1})]);
}

CTAArrow.defaultProps = {"width":"27","height":"27","viewBox":"0 0 27 27","fill":"none"};

module.exports = CTAArrow;

CTAArrow.default = CTAArrow;
